export const isAuthenticated = () => {
  return !!localStorage.getItem('firebase-token');
};
